var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1001_612",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1001_612",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACn0lEQVR4nO2cMU4cQRBFxxIRoXOHJGSkltiqRYiIlCtwBV/BV3BKSOrQgS8wF1jBFAgJUshIbLA2WbMrQAbXzv/d/Z9UeXc9Vc+fntV2naiTMOtjOj2+PjzcRK9FzIW4P85rcL8dzL5d7u1tqzEEQhZizH6H+48wO/pptoFcW5OsClmRcz2YfT3b3f2EXmczvCbkiZhf4f59MNt/7LoP6DV3rQtZKrNZuH+5Ojj4iF57lbxZyN8QcD+4n1xMJjvoPVTFe4WsTE2v6MwkxBWdKYWEojOnkFiemhtFZyIhoejMNSHxfAhQdKYS4ovjTNGZSUgsT42iM5UQX0xN27fOaAHxkphWb53RjY9/m5p2ojO62fG2qan/1hnd5Hhv1Rqd4Y31/5ya2qIzuqGROzXlR2d4E30tU1NudEY3L9YppsTojG5ajDc1ZURndKNi/Knhjs7oBgWyGKMzvCmOL6rojG5GsBU6OsMb4KRldgeJzvCNO3eNHp3RGw7ykhBv/G0fvfFgKz3UHS5BsddppkEvhoGeBl2dOMuxpMvFQEvQ9bu3/ZadQWUien3CRR9LTnRTm0HB0zCj+5aRQVHTYORf+zIoQoQXElkzIJbwUNwvRjJANz5qiqwZEInoi4+sGYCPpfuqImsGoGmYVRlZMxhtGqyByJrBCMfSTTORNYM1SXhoMrJmkPxsuGs6smaQJKJXZAULmUfWcD89m04/Z61F6C/++FBkJUORlQxFVnIh55PJFnpNTbMqBL2e5pEQMiSEDAkhQ0LIkBAyJIQMCSFDQsiQEDIkhAwJIUNCyJAQMiSEDAkhQ0LIkBAyJIQMCSFDQsiQEDIkhAwJIUNCyJAQMiSEDAkhQ0LIkBAyJIQMCSFDQsiQEDIkhAwJEUJ0a+cPbMBmTCVbfz8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.516acba7640bb50c8e802a85304c5108.svg";
export { ForwardRef as ReactComponent };